import { Icons, type IconNames } from './Icons'

export type IconProps = {
  readonly name: IconNames
  readonly size?: number
  readonly title?: string
  readonly className?: string
}

const Icon = ({ name, size = 24, title, className }: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    focusable="false"
    role="img"
    aria-hidden={title ? undefined : true}
    data-cy="icon"
  >
    {title && <title>{title}</title>}
    {Icons[name]}
  </svg>
)

export default Icon
